import React from "react";
import Nav from "./Nav";
import { useNavigate } from "react-router-dom";
import "../../sass/locationSelect.scss";

const LocationSelect = () => {
  const navigate = useNavigate();

  const handleSelectLocation = (systemId) => {
    sessionStorage.setItem("system_id", systemId);
    navigate("/dashboard");
  };

  return (
    <>
      <Nav />
      <div className="location-select-container mx-auto mt-5">
        <div className="text-center mb-5">
          <h2 className="location-select-heading mb-4">サイト</h2>
          <p className="location-select-subheading mb-4">
            表示したいサイトを選択してください。
          </p>
        </div>

        <div className="d-flex justify-content-center gap-4 flex-wrap pb-4">
          {/* Kushiro Card */}
          <div 
            className="location-card-image-only"
            onClick={() => handleSelectLocation(2)}
          >
            <img src="/image_1.png" alt="Kushiro" />
          </div>

          {/* Hirono Card */}
          <div 
            className="location-card-image-only"
            onClick={() => handleSelectLocation(3)}
          >
            <img src="/image_2.png" alt="Hirono" />
          </div>
        </div>
      </div>
    </>
  );
};

export default LocationSelect;
